/* lua.js generated code 0.3.0 */

var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var ItemTipPopout = xClass("ItemTipPopout", function () {
    FrameLoader.loadImageWithPlist("cocos/bag_prop_tag.plist")
    return cc.CSLoader.createNode("cocos/bag_pop.csb")
})
ItemTipPopout.loadResource = function (onSuccess) {
    let res_list = [
        "cocos/bag_prop_tag.plist",
        "cocos/bag_pop.csb"
    ]
    preloadWithLoading(res_list, onSuccess)
}
ItemTipPopout.prototype.ctor = function () {
    var self = this
    self.onTouchOutside = null
    self.bg = null
    self.nameLabel = null
    self.descLabel = null
    self.useButton = null
    self.timeLabel = null
    self.isTiming = false
    self.expireTime = null
    self.timerId = null
    self.onUseButtonClicked = null
    self.init()
}
ItemTipPopout.prototype.init = function () {
    var self = this
    //---------------------------------------------------------
    self.nameBg = self.getChildByName("top_bg")
	self.nameLabel = self.nameBg.getChildByName("txt")
	self.nameLabel.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT)
	var dim = self.nameLabel.getContentSize()
	self.nameLabel.setTextAreaSize(cc.size(dim.width, 0))
	self.nameLabel.ignoreContentAdaptWithSize(true)
    self.nameLabel.setString("")

    self.descBg = self.getChildByName("bottom_bg")
	self.descLabel = self.descBg.getChildByName("txt")
	self.descLabel.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT)
	var dim = self.descLabel.getContentSize()
	self.descLabel.setTextAreaSize(cc.size(dim.width, 0))
	self.descLabel.ignoreContentAdaptWithSize(true)
    self.descLabel.setString("");
    var useBtn = self.descBg.getChildByName("btn_use");
	self.useButton = UIButton.create(useBtn)
	ButtonPushBounceAnim.create(self.useButton)
    var useLabel = useBtn.getChildByName("label")
    useLabel.setPositionY(useLabel.getPositionY()-5)
	useLabel.setString(getText("prop.use"))
	self.useButton.on(UIButtonEvent.Click, ()=>{ self.onUseClicked() })

	self.tail = self.descBg.getChildByName("arrow")

	self.timeLabel = self.descBg.getChildByName("timeLb")
	self.timeLabel.setTextHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)

    function scheduleCountdown() {
        if (self.isTiming) {
            self.timeLabel.setString(self.getTimeLeftStr())
        }
    }
    self.timerId = cc.Director.getInstance().getScheduler().scheduleScriptFunc(scheduleCountdown, 1, false)
    // function onNodeEvent(event) {
    //     if (event === "exit") {
    //         self.stopTimer()
    //     }
    // }
    // self.registerScriptHandler(onNodeEvent)
    self.registerTouchEvents()
}

ItemTipPopout.prototype.cleanup = function () {
    var self = this
    self.stopTimer()
    cc.eventManager.removeListener(self.listener)
    self.listener = null
    cc.Node.prototype.cleanup.call(self)    
}

ItemTipPopout.prototype.stopTimer = function () {
    var self = this
    if (self.timerId) {
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(self.timerId)
        self.timerId = null
    }
}
ItemTipPopout.prototype.getTimeLeftStr = function (expireTime) {
    var self = this
    var leftSeconds = self.expireTime / 1000 - Localhost.timeInSec()
    if (leftSeconds < 0) {
        // WARN: maybe multi result
        return getText("prop.time.over")
    } else {
        var hour = Math.floor(leftSeconds / 3600)
        var min = Math.floor(leftSeconds / 60) - 60 * hour
        var seconds = leftSeconds - min * 60 - hour * 3600
        return string.format("%02d:%02d:%02d", hour, min, seconds) + getText("prop.time.limit")
    }
}
var BOX_HEADER_HEIGHT = 25
var BOX_FOOTER_HEIGHT = 15
var BOX_COMPONENT_MARGIN = 15
ItemTipPopout.prototype.getDesc = function (itemId) {
    if (UserPropData.isRealRewardProp(itemId)){
        return "实物奖励"
    }
    let str = getText("prop.desc." + itemId, table([1, "n", "\n"]))
    if (itemId == GamePropsType.kComplementStar || itemId == GamePropsType.kComplementStar2){
        let addstar_number = MetaManager.getNewAdConfig().addstar_number || 0
        str = str.replace("{addstar_number}", addstar_number)
    }
    return str
}
ItemTipPopout.prototype.setItem = function (itemInfo, forceUseable) {
    var self = this
    var itemId = itemInfo.itemId
    // 判断是否为特殊原道具衍生道具
    if (UserPropData.isInfinitePreProp(itemId)){
        let [ismetaprop, metaPropId] = UserPropData.getInfiniteMetaPreProp(itemId) //将传入道具id转换为元道具
        itemId = metaPropId
    }
    let nameStr = getText("prop.name." + itemId)
    if (UserPropData.isRealRewardProp(itemId)){
        let propMeta = MetaManager.getInstance().getPropMeta(itemId)
        if (propMeta)nameStr = propMeta.propName
    }
    self.nameLabel.setString(nameStr)

    var nameBgHeight = Math.max(62, self.nameLabel.getContentSize().height+BOX_HEADER_HEIGHT+BOX_FOOTER_HEIGHT)
    self.nameBg.setContentSize(cc.size(self.nameBg.getContentSize().width, nameBgHeight))
    self.nameLabel.setPositionY(nameBgHeight-BOX_HEADER_HEIGHT)

    self.descLabel.setString(self.getDesc(itemId))
    var descBgHeight = self.descLabel.getContentSize().height+BOX_HEADER_HEIGHT

    if (itemInfo.isTime) {
        self.isTiming = true
        self.expireTime = itemInfo.expireTime
        self.timeLabel.setVisible(true)
        self.timeLabel.setString(self.getTimeLeftStr())
		descBgHeight = descBgHeight + BOX_COMPONENT_MARGIN + 20
    } else {
        self.isTiming = false
        self.timeLabel.setVisible(false)
    }
    var config = MetaManager.getPropMeta(itemId)
    if (forceUseable != null && forceUseable === false) {
        self.useButton.setVisible(false)
    } else if (config && config.useable) {
        self.useButton.setVisible(true)
        descBgHeight = descBgHeight + BOX_COMPONENT_MARGIN + 62
    } else {
        self.useButton.setVisible(false)
    }

	descBgHeight = Math.max(65, descBgHeight + BOX_FOOTER_HEIGHT)
    self.descBg.setPositionY(self.nameBg.getPositionY()-nameBgHeight)
	self.descBg.setContentSize(cc.size(self.descBg.getContentSize().width, descBgHeight))
	self.descLabel.setPosition(cc.p(self.descLabel.getPositionX(), descBgHeight-BOX_HEADER_HEIGHT/2))
    self.timeLabel.setPosition(cc.p(self.timeLabel.getPositionX(), self.descLabel.getPositionY()-self.descLabel.getContentSize().height-BOX_COMPONENT_MARGIN))
    self.useButton.setPosition(cc.p(self.useButton.getPositionX(), self.descLabel.getPositionY()-self.descLabel.getContentSize().height-BOX_COMPONENT_MARGIN-30))
	self.setContentSize(cc.size(self.getContentSize().width, descBgHeight+nameBgHeight))
	self.tail.setPositionY(12)

    //-------------------
}
ItemTipPopout.prototype.showAsTip = function (title, message, tailDir, width, height, tailx, taily) {
    var self = this
    title = title || ""
    self.nameLabel.setString(title)
    message = message || ""
    self.descLabel.setString(message)
    self.timeLabel.setVisible(false)
    self.useButton.setVisible(false)
    if (width && height) {
        self.setContentSize(width, height)
        //self.bg.setContentSize(width, height)
    } else {
        //var size = self.bg.getBoundingBox()
        var size = self.descBg.getContentSize()
        width = size.width
        height = -12
        console.log("w1:"+width+" h1:"+height)
    }
    tailDir = tailDir || GameItemDirection.kDown
    if (tailDir === GameItemDirection.kDown) {
        console.log("w:"+width+" h:"+height)
        self.tail.setPosition(width * 0.5, -height)
        self.setAnchorPoint(0.5, -1)
    } else if (tailDir === GameItemDirection.kUp) {
        self.tail.setPosition(width * 0.5, 12)
        self.tail.setFlippedY(true)
        self.setAnchorPoint(0.5, 0)
    } else if (tailDir === GameItemDirection.kLeft) {
        self.tail.setPosition(0, -height * 0.5)
        self.tail.setRotation(85)
        self.setAnchorPoint(0, -0.5)
    } else {
        self.tail.setPosition(width - 3, -height * 0.5 - 12)
        self.tail.setRotation(-95)
        self.setAnchorPoint(1, -0.5)
    }
}
ItemTipPopout.prototype.setFlip = function (flip) {
    var self = this
    //self.tail.setFlippedX(flip)
    if (flip) {
        self.tail.setPositionX(85)
    } else {
        self.tail.setPositionX(165)
    }
}
ItemTipPopout.prototype.onUseClicked = function () {
    //var __VA_ARG = $slice(arguments, 0)
    var self = this
    self.onUseButtonClicked()
}
ItemTipPopout.prototype.isTouchInBox = function (touchPos) {
    var self = this
    if (!self.isVisible()) {
        return false
    } else {
        if (he.HeDisplayUtil.hitTestPoint(self, touchPos, true, 0)) {   
           return true
        }
        return false
         
    }
}
ItemTipPopout.prototype.registerTouchEvents = function () {
    var self = this
    function onTouchBegan(touch, event) {
        var tp = touch.getLocation()
        if (self.isTouchInBox(tp)) {
            return true
        } else {
            self.onTouchOutside()
            return false
        }
    }
    var listener = cc.EventListenerTouchOneByOne.create()
    listener.setSwallowTouches(true)
    listener.registerScriptHandler(onTouchBegan, cc.Handler.EVENT_TOUCH_BEGAN)
    cc.eventManager.addListener(listener, self)
    self.listener = listener
    // var eventDispatcher = self.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listener, self)
}
ItemTipPopout.prototype.popout = function () {
    var self = this
    self.stopAllActions()
    self.useButton.setEnabled(true)
    self.setVisible(true)
    self.runAction(cc.Sequence.create(
        cc.ScaleTo.create(0.1, 1.2), 
        cc.ScaleTo.create(0.05, 1),
		cc.DelayTime.create(2),
        cc.CallFunc.create(()=> {
            if (self.onTouchOutside) {
                self.onTouchOutside()
            }
        })
        ))
}
ItemTipPopout.prototype.close = function () {
    var self = this
    self.runAction(cc.Sequence.create(cc.ScaleTo.create(0.1, 0.1), cc.CallFunc.create(function () {
        self.useButton.setEnabled(false)
        self.setVisible(false)
    })))
}
module.exports = ItemTipPopout
